import React from "react";
import { Layout, Typography, Card, Row, Col, Button, Tag } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const plans = [
  {
    name: "Starter Plan",
    price: "$0/month",
    features: [
      "Access to basic AI tutorials",
      "Community support via forum",
      "Limited project challenges",
      "Basic mentorship via community members",
      "Access to free resources and articles",
    ],
    description:
      "Perfect for beginners eager to explore AI! Get started with essential learning materials and peer support from our vibrant community—your first step into the world of AI awaits!",
    tag: "Free",
    tagColor: "green",
  },
  {
    name: "Pro Plan",
    price: "$19/month",
    features: [
      "Advanced AI & ML courses",
      "1-on-1 mentorship with experts",
      "Exclusive challenges and projects",
      "Certificate of completion for every course",
      "Priority support for technical queries",
    ],
    description:
      "Unlock your potential with deeper AI and ML expertise! Enjoy advanced courses, personalized mentorship, and certifications to skyrocket your career—ideal for serious learners.",
    tag: "Best Value",
    tagColor: "blue",
  },
  {
    name: "Enterprise Plan",
    price: "Custom Pricing",
    features: [
      "AI training for teams and employees",
      "Customized learning paths for organizations",
      "Company-sponsored AI/ML projects",
      "Dedicated support with team collaboration",
      "Enterprise-level AI tools and resources",
    ],
    description:
      "Elevate your team with tailored AI training! Designed for companies, this plan offers custom solutions and real-world projects to drive innovation—contact us to revolutionize your workforce.",
    tag: "Premium",
    tagColor: "gold",
  },
];

const AILearningPlans = () => {
  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5", textAlign: "center" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff" }}>
          AI Learning Plans
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "40px" }}>
          Choose the perfect plan to ignite your journey in AI, Cybersecurity, and Data Science. Whether you're a beginner, a pro, or a company, JectHub has the tools to fuel your success!
        </Paragraph>

        <Row gutter={[24, 24]} justify="center">
          {plans.map((plan, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <Card
                title={
                  <div>
                    {plan.name} <Tag color={plan.tagColor} style={{ marginLeft: "8px" }}>{plan.tag}</Tag>
                  </div>
                }
                bordered={false}
                style={{
                  textAlign: "center",
                  boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  height: "100%",
                  background: "#fff",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
                hoverable
                headStyle={{ background: "#e6f7ff", borderBottom: "none", fontSize: "18px", fontWeight: "bold" }}
                bodyStyle={{ padding: "20px" }}
              >
                <Title level={3} style={{ color: "#1890ff", marginBottom: "16px" }}>
                  {plan.price}
                </Title>
                <Paragraph style={{ color: "#666", fontSize: "14px", marginBottom: "20px" }}>
                  {plan.description}
                </Paragraph>
                <ul style={{ textAlign: "left", paddingLeft: "20px", marginBottom: "24px" }}>
                  {plan.features.map((feature, i) => (
                    <li key={i} style={{ color: "#666", fontSize: "14px", marginBottom: "8px" }}>
                      <CheckCircleOutlined style={{ color: "#1890ff", marginRight: "8px" }} /> {feature}
                    </li>
                  ))}
                </ul>
                <Button
                  type="primary"
                  size="large"
                  href="/signin"
                  style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", width: "100%" }}
                >
                  Get Started
                </Button>
              </Card>
            </Col>
          ))}
        </Row>

        <Paragraph style={{ marginTop: "40px", fontSize: "16px", color: "#666" }}>
          Not sure which plan suits you?{" "}
          <a href="/contact" style={{ color: "#1890ff", fontWeight: "bold" }}>
            Contact us
          </a>{" "}
          for personalized guidance to kickstart your AI adventure!
        </Paragraph>
      </Content>
    </Layout>
  );
};

export default AILearningPlans;